import { MutationTree } from 'vuex';
import { LocationOpeningHoursState } from './types';
import locationOpeningHours, { LocationOpeningHours } from '@/shared/model/locationOpeningHours';

export const mutations: MutationTree<LocationOpeningHoursState> = {
  setOpeningHours(state, payload: LocationOpeningHours[]) {
    state.openingHours = payload.map(locationOpeningHours.parse);
  },
}
